import React from 'react';
const WhyVisionMultimodalAi = () => {
    return (
        <div
            className="section-py bg-grey dark:bg-black border-b"
            style={{
                borderImageSource: 'linear-gradient(270deg, rgba(60, 69, 97, 0) 0%, #3C4561 50%, rgba(60, 69, 97, 0) 100%)',
                borderImageSlice: 1,
            }}
        >
            <div className="container xl:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-6">
                        <h2 className="text-primary mb-4" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Why Computer Vision & Multimodal AI Now?
                        </h2>
                        <p
                            className="text-secondary mb-0 dark:text-[#D7DEE5]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200"
                        >
                            Visual data is exploding surveillance feeds, product images, medical scans, drone footage, and customer uploads, but most enterprises struggle to extract value from it at scale. Computer Vision changes that by automating what humans see, while Multimodal AI combines vision with text, audio, and sensor data for deeper contextual intelligence.
                        </p>
                    </div>
                    <div className="lg:col-span-6">
                        <p className="mb-0 dark:text-[#D7DEE5]"
                        data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                            Imagine a quality control system that detects micro-defects in real-time, a retail platform that understands product images and customer queries together, or a healthcare workflow that analyzes radiology scans alongside patient records. Leveraging edge deployment, real-time inference, and explainable AI frameworks, organizations move from reactive manual review to proactive, intelligent automation that&apos;s traceable, compliant, and scalable. From warehouse robotics to brand safety monitoring, from document digitization to predictive maintenance, computer vision is about understanding visual context to drive smarter operations.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default WhyVisionMultimodalAi;
